import { render } from "./adminEvent.vue?vue&type=template&id=8e8d195a"
import script from "./adminEvent.vue?vue&type=script&lang=js"
export * from "./adminEvent.vue?vue&type=script&lang=js"

import "./adminEvent.vue?vue&type=style&index=0&id=8e8d195a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__